import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import { GetExportedZip, GetLatestBulkExports } from "../../../../services/AdminService";
import "./BulkExport.scss";
import CircularProgress from "@mui/material/CircularProgress";
const BulkExportList = ({ refresh }) => {
	const [tableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [downloadingId, setDownloadingId] = useState(null);
	useEffect(() => {
		fetchLatestBulkExports();
	}, [refresh]);

	const fetchLatestBulkExports = async () => {
		try {
			setLoading(true);
			const response = await GetLatestBulkExports();
			console.log("Latest bulk exports response:", response);
			const data = response?.data || [];
			const sortedData = [...data].sort((a, b) => new Date(b.requestedTime) - new Date(a.requestedTime));

			setTableData(sortedData);
		} catch (error) {
			console.error("Error fetching bulk exports", error);
			setTableData([]);
		}
		setLoading(false);
	};

	const handleDownload = async (referenceId) => {
		try {
			setDownloadingId(referenceId);
			const response = await GetExportedZip(referenceId);
			const blob = new Blob([response.data], { type: "application/zip" });
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.download = `BulkExport_${referenceId}.zip`;
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (error) {
			console.error("Download failed", error);
		} finally {
			setDownloadingId(null);
		}
	};

	const columns = useMemo(
		() => [
			{
				header: "Requester",
				accessorKey: "requestedUser",
			},
			{
				header: "Requested Time",
				accessorKey: "requestedTime",
				Cell: ({ cell }) => new Date(cell.getValue()).toLocaleString(),
			},
			{
				header: "Reporting Year",
				accessorKey: "reportingYear"
			},
			{
				header: "Regulation Type(s)",
				accessorKey: "regulationTypes"
			},
			{
				header: "WCN",
				accessorKey: "companyInfo",
			},
			{
				header: "IMOs",
				accessorKey: "imoNumbers",
				Cell: ({ cell }) => {
					const value = cell.getValue();
					return (
						<div className="imo-cell" title={value}>
							{value?.length > 50 ? value.substring(0, 50) + "..." : value}
						</div>
					);
				},
			},
			{
				header: "Status",
				accessorKey: "progress"
			},


		],
		[]
	);

	const table = useMaterialReactTable({
		columns,
		data: tableData,
		state: {
			isLoading: loading,
		},
		enableRowActions: true,
		enablePagination: false,
		enableSorting: false,
		enableColumnFilters: false,
		enableColumnActions: false,
		enableTopToolbar: true,
		enableHiding: false,
		layoutMode: "grid",
		enableStickyHeader: true,
		enableDensityToggle: false,
		enableFullScreenToggle: false,
		enableGlobalFilter: false,
		muiTableContainerProps: {
			sx: {
				maxHeight: "400px",
				overflowY: "auto",
			},
		},
		displayColumnDefOptions: {
			"mrt-row-actions": {
				header: "",
				size: 60,
			},
		},
		renderRowActions: ({ row }) => {
			const isCompleted = row.original.progress?.toLowerCase().includes("completed");

			if (!isCompleted) return null;

			return (
				<Tooltip title="Download">
					<IconButton size="small" onClick={() => handleDownload(row.original.referenceId)}>
						{downloadingId === row.original.referenceId ? <CircularProgress size={18} /> : <DownloadIcon sx={{ color: "#0965b6" }} />}
					</IconButton>
				</Tooltip>
			);
		},
		renderTopToolbarCustomActions: () => (
			<Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
				<Tooltip title="Refresh">
					<IconButton onClick={fetchLatestBulkExports}>
						<RefreshIcon />
					</IconButton>
				</Tooltip>

				<Typography sx={{ fontSize: "13px", color: "#555" }}>
					Click to refresh data
				</Typography>
			</Box>
		),
		muiTableHeadCellProps: {
			sx: {
				backgroundColor: "#042a4c",
				fontWeight: "bold",
				color: "#ffffff",
				fontSize: "12px",
				paddingY: "3px",
			},
		},
	});

	return (
		<Box>
			<MaterialReactTable table={table} />
		</Box>
	);
};

export default BulkExportList;
